const GAEvent = ({ action, data }) => {
  const obj = {
    event: 'senior_iframe',
    iframe_data: {
      action,
      ...data
    },
  };
  window.parent && window.parent.postMessage(JSON.stringify(obj), 'https://www.spv.no'); // window.parent i tilfelle ikke iframe
};

export default GAEvent;
